<template>
  <div class="form-group">
    <ncs-label id="filters.ncs_documents.medium"/>
    <select v-model="selected" :disabled="isDisabled" class="form-control form-control-sm">
      <option v-for="opt in [null, 'Written', 'Spoken', 'Written and Spoken']" :value="opt">
        {{ $tOr('filters.ncs_documents.medium.options', opt) }}
      </option>
    </select>
  </div>
</template>
<script>

export default {
  name: 'MediumFilter',
  props: {
    disabled: {type: Boolean, default: false},
    dependencies: {type: Array, default: () => []},
    requireParents: {type: Boolean, default: false},
  },
  created() {
    this.$store.commit('filters/addFilter', {
      id: 'ncs_documents.medium',
      field: 'ncs_documents.medium',
      dependencies: this.dependencies,
      operator: 'eq',
      default: null
    })
    this.$store.commit('filters/addFilter', {
      id: 'ncs_documents.has_written_and_spoken',
      field: 'ncs_documents.has_written_and_spoken',
      dependencies: this.dependencies,
      operator: 'eq',
      default: null
    })
  },
  computed: {
    isDisabled() {
      return this.disabled || (this.requireParents && this.$store.getters['filters/parentsEmpty'](this.id))
    },
    selected: {
      get() {
        const writtenSpoken = this.$store.getters['filters/selectedValue']('ncs_documents.has_written_and_spoken')
        if (writtenSpoken) return 'Written and Spoken'

        return this.$store.getters['filters/selectedValue']('ncs_documents.medium')
      },
      set(v) {
        if (v === 'Written and Spoken') {
          this.$store.commit('filters/setFilter', {'ncs_documents.has_written_and_spoken': true, 'ncs_documents.medium': null})
        } else {
          this.$store.commit('filters/setFilter', {'ncs_documents.has_written_and_spoken': null, 'ncs_documents.medium': v})
        }
      }
    }
  },
  watch: {
    isDisabled: {
      immediate: true,
      handler(value) {
        if (value) {
          // Value should be null for disabled filters
          this.$store.commit('filters/setFilter', {'ncs_documents.medium': null, 'ncs_documents.has_written_and_spoken': null})
        }
      }
    }
  }
}
</script>